import { addBreakpoint } from 'scripts/marmalade/functions/add-breakpoint';
import { addClassToDocumentAtScrollY } from 'scripts/marmalade/functions/add-class-at-scroll-y';
const html = document.documentElement;
const menu = document.querySelector('.js-menu');
const menuContainer = document.querySelector('.js-menu__container');
const menuNav = document.querySelector('.js-nav__list');
const headerNotification = menu.querySelector('.js-header__notification');
const headerNotificationClose = menu.querySelector('.js-header__notification-close');
addClassToDocumentAtScrollY('scrolled', 100);
addBreakpoint(menu, () => menuContainer.clientWidth < menuNav.clientWidth);

// Header notifications
if (headerNotification) {
  // Close the notification
  headerNotificationClose.addEventListener('click', () => {
    html.classList.remove('header-notification-visible');
    sessionStorage.setItem('SiteNotificationContent', 'true');
  });
}